
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
'use strict';
function $7b9cef12dff8ea2c$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $78b9035ccb9fa80d$var$toString } = Object.prototype;
const { getPrototypeOf: $78b9035ccb9fa80d$var$getPrototypeOf } = Object;
const { iterator: $78b9035ccb9fa80d$var$iterator, toStringTag: $78b9035ccb9fa80d$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $78b9035ccb9fa80d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $78b9035ccb9fa80d$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($78b9035ccb9fa80d$var$hasOwnProperty(obj, prop)) return true;
        obj = $78b9035ccb9fa80d$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $78b9035ccb9fa80d$var$getSafeProp = (obj, prop)=>obj != null && $78b9035ccb9fa80d$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $78b9035ccb9fa80d$var$kindOf = ((cache)=>(thing)=>{
        const str = $78b9035ccb9fa80d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $78b9035ccb9fa80d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$78b9035ccb9fa80d$var$kindOf(thing) === type;
};
const $78b9035ccb9fa80d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $78b9035ccb9fa80d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $78b9035ccb9fa80d$var$isUndefined = $78b9035ccb9fa80d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $78b9035ccb9fa80d$var$isBuffer(val) {
    return val !== null && !$78b9035ccb9fa80d$var$isUndefined(val) && val.constructor !== null && !$78b9035ccb9fa80d$var$isUndefined(val.constructor) && $78b9035ccb9fa80d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $78b9035ccb9fa80d$var$isArrayBuffer = $78b9035ccb9fa80d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $78b9035ccb9fa80d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $78b9035ccb9fa80d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $78b9035ccb9fa80d$var$isString = $78b9035ccb9fa80d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $78b9035ccb9fa80d$var$isFunction = $78b9035ccb9fa80d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $78b9035ccb9fa80d$var$isNumber = $78b9035ccb9fa80d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $78b9035ccb9fa80d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $78b9035ccb9fa80d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $78b9035ccb9fa80d$var$isPlainObject = (val)=>{
    if (!$78b9035ccb9fa80d$var$isObject(val)) return false;
    const prototype = $78b9035ccb9fa80d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $78b9035ccb9fa80d$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$78b9035ccb9fa80d$var$hasOwnInPrototypeChain(val, $78b9035ccb9fa80d$var$toStringTag) && !$78b9035ccb9fa80d$var$hasOwnInPrototypeChain(val, $78b9035ccb9fa80d$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $78b9035ccb9fa80d$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$78b9035ccb9fa80d$var$isObject(val) || $78b9035ccb9fa80d$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $78b9035ccb9fa80d$var$isDate = $78b9035ccb9fa80d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $78b9035ccb9fa80d$var$isFile = $78b9035ccb9fa80d$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $78b9035ccb9fa80d$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $78b9035ccb9fa80d$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $78b9035ccb9fa80d$var$isBlob = $78b9035ccb9fa80d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $78b9035ccb9fa80d$var$isFileList = $78b9035ccb9fa80d$var$kindOfTest('FileList');
const $78b9035ccb9fa80d$var$isSet = $78b9035ccb9fa80d$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $78b9035ccb9fa80d$var$isStream = (val)=>$78b9035ccb9fa80d$var$isObject(val) && $78b9035ccb9fa80d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $78b9035ccb9fa80d$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $78b9035ccb9fa80d$var$G = $78b9035ccb9fa80d$var$getGlobal();
const $78b9035ccb9fa80d$var$FormDataCtor = typeof $78b9035ccb9fa80d$var$G.FormData !== 'undefined' ? $78b9035ccb9fa80d$var$G.FormData : undefined;
const $78b9035ccb9fa80d$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($78b9035ccb9fa80d$var$FormDataCtor && thing instanceof $78b9035ccb9fa80d$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $78b9035ccb9fa80d$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$78b9035ccb9fa80d$var$isFunction(thing.append)) return false;
    const kind = $78b9035ccb9fa80d$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $78b9035ccb9fa80d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $78b9035ccb9fa80d$var$isURLSearchParams = $78b9035ccb9fa80d$var$kindOfTest('URLSearchParams');
const [$78b9035ccb9fa80d$var$isReadableStream, $78b9035ccb9fa80d$var$isRequest, $78b9035ccb9fa80d$var$isResponse, $78b9035ccb9fa80d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($78b9035ccb9fa80d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $78b9035ccb9fa80d$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $78b9035ccb9fa80d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($78b9035ccb9fa80d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($78b9035ccb9fa80d$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $78b9035ccb9fa80d$var$findKey(obj, key) {
    if ($78b9035ccb9fa80d$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $78b9035ccb9fa80d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $78b9035ccb9fa80d$var$isContextDefined = (context)=>!$78b9035ccb9fa80d$var$isUndefined(context) && context !== $78b9035ccb9fa80d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $78b9035ccb9fa80d$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $78b9035ccb9fa80d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $78b9035ccb9fa80d$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $78b9035ccb9fa80d$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($78b9035ccb9fa80d$var$isPlainObject(existing) && $78b9035ccb9fa80d$var$isPlainObject(val)) result[targetKey] = $78b9035ccb9fa80d$var$merge(existing, val);
        else if ($78b9035ccb9fa80d$var$isPlainObject(val)) result[targetKey] = $78b9035ccb9fa80d$var$merge({}, val);
        else if ($78b9035ccb9fa80d$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$78b9035ccb9fa80d$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $78b9035ccb9fa80d$var$isBuffer(source)) continue;
        $78b9035ccb9fa80d$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $78b9035ccb9fa80d$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($78b9035ccb9fa80d$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $78b9035ccb9fa80d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $78b9035ccb9fa80d$var$forEach(b, (val, key)=>{
        if (thisArg && $78b9035ccb9fa80d$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $7b9cef12dff8ea2c$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $78b9035ccb9fa80d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $78b9035ccb9fa80d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $78b9035ccb9fa80d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $78b9035ccb9fa80d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $78b9035ccb9fa80d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $78b9035ccb9fa80d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($78b9035ccb9fa80d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$78b9035ccb9fa80d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $78b9035ccb9fa80d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $78b9035ccb9fa80d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $78b9035ccb9fa80d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$78b9035ccb9fa80d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $78b9035ccb9fa80d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $78b9035ccb9fa80d$var$isHTMLForm = $78b9035ccb9fa80d$var$kindOfTest('HTMLFormElement');
const $78b9035ccb9fa80d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $78b9035ccb9fa80d$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $78b9035ccb9fa80d$var$isRegExp = $78b9035ccb9fa80d$var$kindOfTest('RegExp');
const $78b9035ccb9fa80d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $78b9035ccb9fa80d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $78b9035ccb9fa80d$var$freezeMethods = (obj)=>{
    $78b9035ccb9fa80d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($78b9035ccb9fa80d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$78b9035ccb9fa80d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $78b9035ccb9fa80d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $78b9035ccb9fa80d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $78b9035ccb9fa80d$var$noop = ()=>{};
const $78b9035ccb9fa80d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $78b9035ccb9fa80d$var$isSpecCompliantForm(thing) {
    return !!(thing && $78b9035ccb9fa80d$var$isFunction(thing.append) && thing[$78b9035ccb9fa80d$var$toStringTag] === 'FormData' && thing[$78b9035ccb9fa80d$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $78b9035ccb9fa80d$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($78b9035ccb9fa80d$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($78b9035ccb9fa80d$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($78b9035ccb9fa80d$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$78b9035ccb9fa80d$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $78b9035ccb9fa80d$var$isArray(source) ? [] : {};
                    $78b9035ccb9fa80d$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$78b9035ccb9fa80d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $78b9035ccb9fa80d$var$isAsyncFn = $78b9035ccb9fa80d$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $78b9035ccb9fa80d$var$isThenable = (thing)=>thing && ($78b9035ccb9fa80d$var$isObject(thing) || $78b9035ccb9fa80d$var$isFunction(thing)) && $78b9035ccb9fa80d$var$isFunction(thing.then) && $78b9035ccb9fa80d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $78b9035ccb9fa80d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $78b9035ccb9fa80d$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $78b9035ccb9fa80d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $78b9035ccb9fa80d$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $78b9035ccb9fa80d$var$isFunction($78b9035ccb9fa80d$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $78b9035ccb9fa80d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($78b9035ccb9fa80d$var$_global) : $78b9035ccb9fa80d$var$_setImmediate;
// *********************
const $78b9035ccb9fa80d$var$isIterable = (thing)=>thing != null && $78b9035ccb9fa80d$var$isFunction(thing[$78b9035ccb9fa80d$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $78b9035ccb9fa80d$var$isSafeIterable = (thing)=>thing != null && $78b9035ccb9fa80d$var$hasOwnInPrototypeChain(thing, $78b9035ccb9fa80d$var$iterator) && $78b9035ccb9fa80d$var$isIterable(thing);
var $78b9035ccb9fa80d$export$2e2bcd8739ae039 = {
    isArray: $78b9035ccb9fa80d$var$isArray,
    isArrayBuffer: $78b9035ccb9fa80d$var$isArrayBuffer,
    isBuffer: $78b9035ccb9fa80d$var$isBuffer,
    isFormData: $78b9035ccb9fa80d$var$isFormData,
    isArrayBufferView: $78b9035ccb9fa80d$var$isArrayBufferView,
    isString: $78b9035ccb9fa80d$var$isString,
    isNumber: $78b9035ccb9fa80d$var$isNumber,
    isBoolean: $78b9035ccb9fa80d$var$isBoolean,
    isObject: $78b9035ccb9fa80d$var$isObject,
    isPlainObject: $78b9035ccb9fa80d$var$isPlainObject,
    isEmptyObject: $78b9035ccb9fa80d$var$isEmptyObject,
    isReadableStream: $78b9035ccb9fa80d$var$isReadableStream,
    isRequest: $78b9035ccb9fa80d$var$isRequest,
    isResponse: $78b9035ccb9fa80d$var$isResponse,
    isHeaders: $78b9035ccb9fa80d$var$isHeaders,
    isUndefined: $78b9035ccb9fa80d$var$isUndefined,
    isDate: $78b9035ccb9fa80d$var$isDate,
    isFile: $78b9035ccb9fa80d$var$isFile,
    isReactNativeBlob: $78b9035ccb9fa80d$var$isReactNativeBlob,
    isReactNative: $78b9035ccb9fa80d$var$isReactNative,
    isBlob: $78b9035ccb9fa80d$var$isBlob,
    isRegExp: $78b9035ccb9fa80d$var$isRegExp,
    isFunction: $78b9035ccb9fa80d$var$isFunction,
    isStream: $78b9035ccb9fa80d$var$isStream,
    isURLSearchParams: $78b9035ccb9fa80d$var$isURLSearchParams,
    isTypedArray: $78b9035ccb9fa80d$var$isTypedArray,
    isFileList: $78b9035ccb9fa80d$var$isFileList,
    forEach: $78b9035ccb9fa80d$var$forEach,
    merge: $78b9035ccb9fa80d$var$merge,
    extend: $78b9035ccb9fa80d$var$extend,
    trim: $78b9035ccb9fa80d$var$trim,
    stripBOM: $78b9035ccb9fa80d$var$stripBOM,
    inherits: $78b9035ccb9fa80d$var$inherits,
    toFlatObject: $78b9035ccb9fa80d$var$toFlatObject,
    kindOf: $78b9035ccb9fa80d$var$kindOf,
    kindOfTest: $78b9035ccb9fa80d$var$kindOfTest,
    endsWith: $78b9035ccb9fa80d$var$endsWith,
    toArray: $78b9035ccb9fa80d$var$toArray,
    forEachEntry: $78b9035ccb9fa80d$var$forEachEntry,
    matchAll: $78b9035ccb9fa80d$var$matchAll,
    isHTMLForm: $78b9035ccb9fa80d$var$isHTMLForm,
    hasOwnProperty: $78b9035ccb9fa80d$var$hasOwnProperty,
    hasOwnProp: $78b9035ccb9fa80d$var$hasOwnProperty,
    hasOwnInPrototypeChain: $78b9035ccb9fa80d$var$hasOwnInPrototypeChain,
    getSafeProp: $78b9035ccb9fa80d$var$getSafeProp,
    reduceDescriptors: $78b9035ccb9fa80d$var$reduceDescriptors,
    freezeMethods: $78b9035ccb9fa80d$var$freezeMethods,
    toObjectSet: $78b9035ccb9fa80d$var$toObjectSet,
    toCamelCase: $78b9035ccb9fa80d$var$toCamelCase,
    noop: $78b9035ccb9fa80d$var$noop,
    toFiniteNumber: $78b9035ccb9fa80d$var$toFiniteNumber,
    findKey: $78b9035ccb9fa80d$var$findKey,
    global: $78b9035ccb9fa80d$var$_global,
    isContextDefined: $78b9035ccb9fa80d$var$isContextDefined,
    isSpecCompliantForm: $78b9035ccb9fa80d$var$isSpecCompliantForm,
    toJSONObject: $78b9035ccb9fa80d$var$toJSONObject,
    isAsyncFn: $78b9035ccb9fa80d$var$isAsyncFn,
    isThenable: $78b9035ccb9fa80d$var$isThenable,
    setImmediate: $78b9035ccb9fa80d$var$_setImmediate,
    asap: $78b9035ccb9fa80d$var$asap,
    isIterable: $78b9035ccb9fa80d$var$isIterable,
    isSafeIterable: $78b9035ccb9fa80d$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $99650eab0d0b0149$var$ignoreDuplicateOf = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $99650eab0d0b0149$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp($99650eab0d0b0149$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $139ef1de983c600c$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $139ef1de983c600c$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $139ef1de983c600c$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $139ef1de983c600c$var$sanitizeValue(value, invalidChars) {
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$139ef1de983c600c$var$sanitizeValue(item, invalidChars));
    return $139ef1de983c600c$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $139ef1de983c600c$export$9e344cffce061a22 = (value)=>$139ef1de983c600c$var$sanitizeValue(value, $139ef1de983c600c$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $139ef1de983c600c$export$59dd66c2a12d8f62 = (value)=>$139ef1de983c600c$var$sanitizeValue(value, $139ef1de983c600c$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $139ef1de983c600c$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $139ef1de983c600c$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $b6e5c6ddea651d0a$var$$internals = Symbol('internals');
function $b6e5c6ddea651d0a$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $b6e5c6ddea651d0a$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(value) ? value.map($b6e5c6ddea651d0a$var$normalizeValue) : (0, $139ef1de983c600c$export$9e344cffce061a22)(String(value));
}
function $b6e5c6ddea651d0a$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $b6e5c6ddea651d0a$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $b6e5c6ddea651d0a$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $b6e5c6ddea651d0a$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $b6e5c6ddea651d0a$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $b6e5c6ddea651d0a$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $b6e5c6ddea651d0a$var$trimOWS(part.slice(0, equals));
        if (!$b6e5c6ddea651d0a$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $b6e5c6ddea651d0a$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $b6e5c6ddea651d0a$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $b6e5c6ddea651d0a$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $b6e5c6ddea651d0a$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $b6e5c6ddea651d0a$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $b6e5c6ddea651d0a$var$buildAccessors(obj, header) {
    const accessorName = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $b6e5c6ddea651d0a$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $b6e5c6ddea651d0a$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $b6e5c6ddea651d0a$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$b6e5c6ddea651d0a$var$isValidHeaderName(header)) setHeaders((0, $99650eab0d0b0149$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isObject(header) && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $b6e5c6ddea651d0a$var$normalizeHeader(header);
        if (header) {
            const key = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $b6e5c6ddea651d0a$var$parseTokens(value);
                if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $b6e5c6ddea651d0a$var$normalizeHeader(header);
        if (header) {
            const key = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $b6e5c6ddea651d0a$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $b6e5c6ddea651d0a$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $b6e5c6ddea651d0a$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $b6e5c6ddea651d0a$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $b6e5c6ddea651d0a$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $b6e5c6ddea651d0a$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $b6e5c6ddea651d0a$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $b6e5c6ddea651d0a$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$b6e5c6ddea651d0a$var$$internals] = this[$b6e5c6ddea651d0a$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $b6e5c6ddea651d0a$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $b6e5c6ddea651d0a$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$b6e5c6ddea651d0a$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).reduceDescriptors($b6e5c6ddea651d0a$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).freezeMethods($b6e5c6ddea651d0a$var$AxiosHeaders);
var $b6e5c6ddea651d0a$export$2e2bcd8739ae039 = $b6e5c6ddea651d0a$var$AxiosHeaders;


'use strict';
const $ed343e8da33d436f$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $ed343e8da33d436f$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $ed343e8da33d436f$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isPlainObject(source) && $ed343e8da33d436f$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $ed343e8da33d436f$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $ed343e8da33d436f$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $ed343e8da33d436f$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $ed343e8da33d436f$var$stringifySafely(entry.message) : $ed343e8da33d436f$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $ed343e8da33d436f$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $ed343e8da33d436f$var$aggregateErrorMessage(error);
        const axiosError = new $ed343e8da33d436f$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $ed343e8da33d436f$var$redactConfig(config, redactKeys) : (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$ed343e8da33d436f$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$ed343e8da33d436f$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$ed343e8da33d436f$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$ed343e8da33d436f$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$ed343e8da33d436f$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$ed343e8da33d436f$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$ed343e8da33d436f$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$ed343e8da33d436f$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$ed343e8da33d436f$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$ed343e8da33d436f$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$ed343e8da33d436f$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$ed343e8da33d436f$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$ed343e8da33d436f$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$ed343e8da33d436f$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $ed343e8da33d436f$export$2e2bcd8739ae039 = $ed343e8da33d436f$var$AxiosError;


// eslint-disable-next-line strict
var $4603020cbd73b477$export$2e2bcd8739ae039 = null;



'use strict';
const $d9acf3c3cff7ac06$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $d9acf3c3cff7ac06$var$isVisitable(thing) {
    return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $d9acf3c3cff7ac06$var$removeBrackets(key) {
    return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $d9acf3c3cff7ac06$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $d9acf3c3cff7ac06$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $d9acf3c3cff7ac06$var$isFlatArray(arr) {
    return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($d9acf3c3cff7ac06$var$isVisitable);
}
const $d9acf3c3cff7ac06$var$predicates = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toFlatObject((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $d9acf3c3cff7ac06$var$toFormData(obj, formData, options) {
    if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4603020cbd73b477$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $d9acf3c3cff7ac06$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $4603020cbd73b477$export$2e2bcd8739ae039) && (0, $4603020cbd73b477$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $4603020cbd73b477$export$2e2bcd8739ae039).from(value);
            throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isReactNative(formData) && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($d9acf3c3cff7ac06$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(value) && $d9acf3c3cff7ac06$var$isFlatArray(value) || ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFileList(value) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $d9acf3c3cff7ac06$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $d9acf3c3cff7ac06$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($d9acf3c3cff7ac06$var$isVisitable(value)) return true;
        formData.append($d9acf3c3cff7ac06$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($d9acf3c3cff7ac06$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $d9acf3c3cff7ac06$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $d9acf3c3cff7ac06$export$2e2bcd8739ae039 = $d9acf3c3cff7ac06$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $c2358268ff78dd45$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $c2358268ff78dd45$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $d9acf3c3cff7ac06$export$2e2bcd8739ae039)(params, this, options);
}
const $c2358268ff78dd45$var$prototype = $c2358268ff78dd45$var$AxiosURLSearchParams.prototype;
$c2358268ff78dd45$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$c2358268ff78dd45$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $c2358268ff78dd45$var$encode) : $c2358268ff78dd45$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $c2358268ff78dd45$export$2e2bcd8739ae039 = $c2358268ff78dd45$var$AxiosURLSearchParams;


'use strict';
function $9b9cf3e96ac1aada$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $9b9cf3e96ac1aada$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $9b9cf3e96ac1aada$export$c564cdbbe6da493;
    const serializeFn = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $c2358268ff78dd45$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $4ecd25ee7358a691$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $4ecd25ee7358a691$export$2e2bcd8739ae039 = $4ecd25ee7358a691$var$InterceptorManager;





'use strict';
var $759bfd722f13f29f$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $6f8ac830db50b2fe$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $c2358268ff78dd45$export$2e2bcd8739ae039);


'use strict';
var $c2e2c8d025e32f70$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $608de49263153b6c$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $b05ae602455bccdb$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6f8ac830db50b2fe$export$2e2bcd8739ae039,
        FormData: $c2e2c8d025e32f70$export$2e2bcd8739ae039,
        Blob: $608de49263153b6c$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $66be5f918ed1c2ae$exports = {};

$parcel$export($66be5f918ed1c2ae$exports, "hasBrowserEnv", () => $66be5f918ed1c2ae$export$c4996c4b7b93b0bf);
$parcel$export($66be5f918ed1c2ae$exports, "navigator", () => $66be5f918ed1c2ae$export$ec7c8efa7f5790ae);
$parcel$export($66be5f918ed1c2ae$exports, "hasStandardBrowserEnv", () => $66be5f918ed1c2ae$export$c0bcc9250309d66);
$parcel$export($66be5f918ed1c2ae$exports, "hasStandardBrowserWebWorkerEnv", () => $66be5f918ed1c2ae$export$c81692cf5af97dac);
$parcel$export($66be5f918ed1c2ae$exports, "origin", () => $66be5f918ed1c2ae$export$f710a83a91838a36);
const $66be5f918ed1c2ae$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $66be5f918ed1c2ae$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $66be5f918ed1c2ae$export$c0bcc9250309d66 = $66be5f918ed1c2ae$export$c4996c4b7b93b0bf && (!$66be5f918ed1c2ae$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($66be5f918ed1c2ae$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $66be5f918ed1c2ae$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $66be5f918ed1c2ae$export$f710a83a91838a36 = $66be5f918ed1c2ae$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $c27b1e2774499bca$export$2e2bcd8739ae039 = {
    ...$66be5f918ed1c2ae$exports,
    ...(0, $b05ae602455bccdb$export$2e2bcd8739ae039)
};


'use strict';
function $f5b5e4548e751e4f$export$2e2bcd8739ae039(data, options) {
    return (0, $d9acf3c3cff7ac06$export$2e2bcd8739ae039)(data, new (0, $c27b1e2774499bca$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $c27b1e2774499bca$export$2e2bcd8739ae039).isNode && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $0675de30d150073f$var$MAX_DEPTH = (0, $d9acf3c3cff7ac06$export$659081b45d03227d);
function $0675de30d150073f$var$throwIfDepthExceeded(index) {
    if (index > $0675de30d150073f$var$MAX_DEPTH) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $0675de30d150073f$var$MAX_DEPTH, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $0675de30d150073f$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $0675de30d150073f$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $0675de30d150073f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $0675de30d150073f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $0675de30d150073f$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $0675de30d150073f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFormData(formData) && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($0675de30d150073f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $0675de30d150073f$export$2e2bcd8739ae039 = $0675de30d150073f$var$formDataToJSON;


'use strict';
const $f83af6422314c92f$var$own = (obj, key)=>obj != null && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f83af6422314c92f$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f83af6422314c92f$var$defaults = {
    transitional: (0, $759bfd722f13f29f$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $0675de30d150073f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isBuffer(data) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isStream(data) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFile(data) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isBlob(data) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $f83af6422314c92f$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f5b5e4548e751e4f$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $f83af6422314c92f$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $d9acf3c3cff7ac06$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $f83af6422314c92f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $f83af6422314c92f$var$own(this, 'transitional') || $f83af6422314c92f$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $f83af6422314c92f$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isResponse(data) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $f83af6422314c92f$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $ed343e8da33d436f$export$2e2bcd8739ae039).from(e, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $f83af6422314c92f$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $c27b1e2774499bca$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $c27b1e2774499bca$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $f83af6422314c92f$var$defaults.headers[method] = {};
});
var $f83af6422314c92f$export$2e2bcd8739ae039 = $f83af6422314c92f$var$defaults;



'use strict';
function $9a0970cd287b9c9d$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f83af6422314c92f$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $4b3ddc3f27c0672d$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $429dbe1339fd51a8$var$CanceledError extends (0, $ed343e8da33d436f$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $429dbe1339fd51a8$export$2e2bcd8739ae039 = $429dbe1339fd51a8$var$CanceledError;







'use strict';
function $d2f3b931c4b1d326$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $0cff15065b35d85e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d6f668b0efd1ca80$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d6f668b0efd1ca80$export$2e2bcd8739ae039 = $d6f668b0efd1ca80$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $3f60fe6c0ed111e6$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $3f60fe6c0ed111e6$export$2e2bcd8739ae039 = $3f60fe6c0ed111e6$var$throttle;



const $f638f3763959a198$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d6f668b0efd1ca80$export$2e2bcd8739ae039)(50, 250);
    return (0, $3f60fe6c0ed111e6$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $f638f3763959a198$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $f638f3763959a198$export$5d35863c355a22a9 = (fn, scheduler = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $05628b8f543da131$export$2e2bcd8739ae039 = (0, $c27b1e2774499bca$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $c27b1e2774499bca$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $c27b1e2774499bca$export$2e2bcd8739ae039).origin), (0, $c27b1e2774499bca$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $c27b1e2774499bca$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $f5a5851d78fb0142$export$2e2bcd8739ae039 = (0, $c27b1e2774499bca$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $a4ee48c5d2b2ef8c$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $5d9f7ea19bd486f3$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}


'use strict';
const $b336420e9357acff$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $b336420e9357acff$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $b336420e9357acff$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $b336420e9357acff$var$normalizeURLForProtocolCheck(url) {
    return $b336420e9357acff$var$stripLeadingC0ControlOrSpace(url).replace($b336420e9357acff$var$httpProtocolControlCharacters, '');
}
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $b336420e9357acff$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $ed343e8da33d436f$export$6acd2efa8ac62a1b}`;
    });
}
function $b336420e9357acff$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $ed343e8da33d436f$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $ed343e8da33d436f$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$b336420e9357acff$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $b336420e9357acff$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = $b336420e9357acff$var$normalizeURLForProtocolCheck(url);
        if ($b336420e9357acff$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($b336420e9357acff$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $b336420e9357acff$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $b336420e9357acff$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $a4ee48c5d2b2ef8c$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $b336420e9357acff$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $5d9f7ea19bd486f3$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $f9425f956f68959d$var$headersToObject = (thing)=>thing instanceof (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
const $f9425f956f68959d$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $f9425f956f68959d$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f9425f956f68959d$var$headersToObject(a), $f9425f956f68959d$var$headersToObject(b), prop, true)
    };
    (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach($f9425f956f68959d$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $a613d56b1a7e4e71$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $a613d56b1a7e4e71$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($a613d56b1a7e4e71$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $1a2274514da2edeb$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $1a2274514da2edeb$var$resolveConfig(config) {
    const newConfig = (0, $f9425f956f68959d$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $9b9cf3e96ac1aada$export$2e2bcd8739ae039)((0, $b336420e9357acff$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $1a2274514da2edeb$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $ed343e8da33d436f$export$2e2bcd8739ae039).from(e, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $c27b1e2774499bca$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $c27b1e2774499bca$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        (0, $a613d56b1a7e4e71$export$2e2bcd8739ae039)(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $c27b1e2774499bca$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $05628b8f543da131$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $f5a5851d78fb0142$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $1a2274514da2edeb$export$2e2bcd8739ae039 = $1a2274514da2edeb$var$resolveConfig;



const $b412e65f8d3d95e3$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $b412e65f8d3d95e3$export$2e2bcd8739ae039 = $b412e65f8d3d95e3$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $1a2274514da2edeb$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $d2f3b931c4b1d326$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Request aborted', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)(msg, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $759bfd722f13f29f$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach((0, $139ef1de983c600c$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $f638f3763959a198$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $f638f3763959a198$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $429dbe1339fd51a8$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $0cff15065b35d85e$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $c27b1e2774499bca$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $c5a1cf59112b5a87$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $ed343e8da33d436f$export$2e2bcd8739ae039) ? err : new (0, $429dbe1339fd51a8$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $c5a1cf59112b5a87$export$2e2bcd8739ae039 = $c5a1cf59112b5a87$var$composeSignals;


const $0c7be4119f7f7bbf$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $0c7be4119f7f7bbf$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $0c7be4119f7f7bbf$var$readStream(iterable))yield* $0c7be4119f7f7bbf$export$71b051935044bd5d(chunk, chunkSize);
};
const $0c7be4119f7f7bbf$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $0c7be4119f7f7bbf$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $0c7be4119f7f7bbf$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $b93b43ad76ab4fb5$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $b93b43ad76ab4fb5$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $b93b43ad76ab4fb5$var$isHexDigit(str.charCodeAt(i + 1)) && $b93b43ad76ab4fb5$var$isHexDigit(str.charCodeAt(i + 2));
const $b93b43ad76ab4fb5$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $b93b43ad76ab4fb5$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $b93b43ad76ab4fb5$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $b93b43ad76ab4fb5$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $b93b43ad76ab4fb5$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $b93b43ad76ab4fb5$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $b93b43ad76ab4fb5$var$isPercentEncodedByte(body, i, len)) {
            code = $b93b43ad76ab4fb5$var$hexValue(body.charCodeAt(i + 1)) * 16 + $b93b43ad76ab4fb5$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($b93b43ad76ab4fb5$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$b93b43ad76ab4fb5$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $b93b43ad76ab4fb5$var$estimateBase64BufferAllocation(body);
    return $b93b43ad76ab4fb5$var$base64Bytes(significant);
};
const $b93b43ad76ab4fb5$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $b93b43ad76ab4fb5$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $b93b43ad76ab4fb5$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $b93b43ad76ab4fb5$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $b93b43ad76ab4fb5$var$estimatePercentDecodedBase64Bytes);
}
function $b93b43ad76ab4fb5$export$1f39e64b554a246f(url) {
    return $b93b43ad76ab4fb5$var$estimateDataURLBytes(url, $b93b43ad76ab4fb5$var$estimateBase64BufferAllocation);
}


const $35c760276741cc91$export$a4ad2735b021c132 = "1.19.0";



const $267bf2dfb6e378d2$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $267bf2dfb6e378d2$var$isFunction } = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $267bf2dfb6e378d2$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $267bf2dfb6e378d2$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $267bf2dfb6e378d2$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $267bf2dfb6e378d2$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $267bf2dfb6e378d2$var$factory = (env)=>{
    const globalObject = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).global !== undefined && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).global !== null ? (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $267bf2dfb6e378d2$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $267bf2dfb6e378d2$var$isFunction(Request);
    const isResponseSupported = $267bf2dfb6e378d2$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $267bf2dfb6e378d2$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $267bf2dfb6e378d2$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $c27b1e2774499bca$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $267bf2dfb6e378d2$var$test(()=>(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $c27b1e2774499bca$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $1a2274514da2edeb$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $c5a1cf59112b5a87$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($267bf2dfb6e378d2$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $c27b1e2774499bca$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $267bf2dfb6e378d2$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $267bf2dfb6e378d2$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($267bf2dfb6e378d2$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $b93b43ad76ab4fb5$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isReadableStream(data) || (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $0c7be4119f7f7bbf$export$b0119225647bd83)(stream, $267bf2dfb6e378d2$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $f638f3763959a198$export$d9fadd12586c18d6)(requestContentLength, (0, $f638f3763959a198$export$c1b28109d46c3592)((0, $f638f3763959a198$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $35c760276741cc91$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $139ef1de983c600c$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $f638f3763959a198$export$d9fadd12586c18d6)(responseContentLength, (0, $f638f3763959a198$export$c1b28109d46c3592)((0, $f638f3763959a198$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $0c7be4119f7f7bbf$export$b0119225647bd83)(response.body, $267bf2dfb6e378d2$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $d2f3b931c4b1d326$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $ed343e8da33d436f$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $ed343e8da33d436f$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Network Error', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $ed343e8da33d436f$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $267bf2dfb6e378d2$var$seedCache = new Map();
const $267bf2dfb6e378d2$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $267bf2dfb6e378d2$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $267bf2dfb6e378d2$var$factory(env));
        map = target;
    }
    return target;
};
const $267bf2dfb6e378d2$var$adapter = $267bf2dfb6e378d2$export$3105c6651375d4fa();
var $267bf2dfb6e378d2$export$2e2bcd8739ae039 = $267bf2dfb6e378d2$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $21b08fac56477792$var$knownAdapters = {
    http: (0, $4603020cbd73b477$export$2e2bcd8739ae039),
    xhr: (0, $b412e65f8d3d95e3$export$2e2bcd8739ae039),
    fetch: {
        get: $267bf2dfb6e378d2$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach($21b08fac56477792$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $21b08fac56477792$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $21b08fac56477792$var$isResolvedHandle = (adapter)=>(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $21b08fac56477792$var$getAdapter(adapters, config) {
    adapters = (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$21b08fac56477792$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $21b08fac56477792$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($21b08fac56477792$var$renderReason).join('\n') : ' ' + $21b08fac56477792$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $21b08fac56477792$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $21b08fac56477792$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $21b08fac56477792$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $24fbcfb2cb23a7d9$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $429dbe1339fd51a8$export$2e2bcd8739ae039)(null, config);
}
function $24fbcfb2cb23a7d9$export$2e2bcd8739ae039(config) {
    $24fbcfb2cb23a7d9$var$throwIfCancellationRequested(config);
    config.headers = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $9a0970cd287b9c9d$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $21b08fac56477792$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f83af6422314c92f$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $24fbcfb2cb23a7d9$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $9a0970cd287b9c9d$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $4b3ddc3f27c0672d$export$2e2bcd8739ae039)(reason)) {
            $24fbcfb2cb23a7d9$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $9a0970cd287b9c9d$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $801eacabb6c05107$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $801eacabb6c05107$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $801eacabb6c05107$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $801eacabb6c05107$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $35c760276741cc91$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$801eacabb6c05107$var$deprecatedWarnings[opt]) {
            $801eacabb6c05107$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$801eacabb6c05107$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $801eacabb6c05107$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('options must be an object', (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ed343e8da33d436f$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $ed343e8da33d436f$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $801eacabb6c05107$export$2e2bcd8739ae039 = {
    assertOptions: $801eacabb6c05107$var$assertOptions,
    validators: $801eacabb6c05107$var$validators
};




'use strict';
const $79c0e4ec2e0260fe$var$validators = (0, $801eacabb6c05107$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $79c0e4ec2e0260fe$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $4ecd25ee7358a691$export$2e2bcd8739ae039)(),
            response: new (0, $4ecd25ee7358a691$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f9425f956f68959d$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $801eacabb6c05107$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $79c0e4ec2e0260fe$var$validators.transitional($79c0e4ec2e0260fe$var$validators.boolean),
            forcedJSONParsing: $79c0e4ec2e0260fe$var$validators.transitional($79c0e4ec2e0260fe$var$validators.boolean),
            clarifyTimeoutError: $79c0e4ec2e0260fe$var$validators.transitional($79c0e4ec2e0260fe$var$validators.boolean),
            legacyInterceptorReqResOrdering: $79c0e4ec2e0260fe$var$validators.transitional($79c0e4ec2e0260fe$var$validators.boolean),
            advertiseZstdAcceptEncoding: $79c0e4ec2e0260fe$var$validators.transitional($79c0e4ec2e0260fe$var$validators.boolean),
            validateStatusUndefinedResolves: $79c0e4ec2e0260fe$var$validators.transitional($79c0e4ec2e0260fe$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $801eacabb6c05107$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $79c0e4ec2e0260fe$var$validators.function,
                serialize: $79c0e4ec2e0260fe$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $801eacabb6c05107$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $79c0e4ec2e0260fe$var$validators.spelling('baseURL'),
            withXsrfToken: $79c0e4ec2e0260fe$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $759bfd722f13f29f$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $24fbcfb2cb23a7d9$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $24fbcfb2cb23a7d9$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $24fbcfb2cb23a7d9$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f9425f956f68959d$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $b336420e9357acff$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $9b9cf3e96ac1aada$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $79c0e4ec2e0260fe$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f9425f956f68959d$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f9425f956f68959d$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $79c0e4ec2e0260fe$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $79c0e4ec2e0260fe$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $79c0e4ec2e0260fe$export$2e2bcd8739ae039 = $79c0e4ec2e0260fe$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $740c0319fee07f92$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $429dbe1339fd51a8$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $740c0319fee07f92$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $740c0319fee07f92$export$2e2bcd8739ae039 = $740c0319fee07f92$var$CancelToken;






'use strict';
function $3ae07325271430e7$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $90266973a21ed1d1$export$2e2bcd8739ae039(payload) {
    return (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $fcff87eec52eadf9$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($fcff87eec52eadf9$var$HttpStatusCode).forEach(([key, value])=>{
    $fcff87eec52eadf9$var$HttpStatusCode[value] = key;
});
var $fcff87eec52eadf9$export$2e2bcd8739ae039 = $fcff87eec52eadf9$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $8b73d7db89efeff6$var$createInstance(defaultConfig) {
    const context = new (0, $79c0e4ec2e0260fe$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $7b9cef12dff8ea2c$export$2e2bcd8739ae039)((0, $79c0e4ec2e0260fe$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).extend(instance, (0, $79c0e4ec2e0260fe$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $8b73d7db89efeff6$var$createInstance((0, $f9425f956f68959d$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $8b73d7db89efeff6$var$axios = $8b73d7db89efeff6$var$createInstance((0, $f83af6422314c92f$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$8b73d7db89efeff6$var$axios.Axios = (0, $79c0e4ec2e0260fe$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$8b73d7db89efeff6$var$axios.CanceledError = (0, $429dbe1339fd51a8$export$2e2bcd8739ae039);
$8b73d7db89efeff6$var$axios.CancelToken = (0, $740c0319fee07f92$export$2e2bcd8739ae039);
$8b73d7db89efeff6$var$axios.isCancel = (0, $4b3ddc3f27c0672d$export$2e2bcd8739ae039);
$8b73d7db89efeff6$var$axios.VERSION = (0, $35c760276741cc91$export$a4ad2735b021c132);
$8b73d7db89efeff6$var$axios.toFormData = (0, $d9acf3c3cff7ac06$export$2e2bcd8739ae039);
// Expose AxiosError class
$8b73d7db89efeff6$var$axios.AxiosError = (0, $ed343e8da33d436f$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$8b73d7db89efeff6$var$axios.Cancel = $8b73d7db89efeff6$var$axios.CanceledError;
// Expose all/spread
$8b73d7db89efeff6$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$8b73d7db89efeff6$var$axios.spread = (0, $3ae07325271430e7$export$2e2bcd8739ae039);
// Expose isAxiosError
$8b73d7db89efeff6$var$axios.isAxiosError = (0, $90266973a21ed1d1$export$2e2bcd8739ae039);
// Expose mergeConfig
$8b73d7db89efeff6$var$axios.mergeConfig = (0, $f9425f956f68959d$export$2e2bcd8739ae039);
$8b73d7db89efeff6$var$axios.AxiosHeaders = (0, $b6e5c6ddea651d0a$export$2e2bcd8739ae039);
$8b73d7db89efeff6$var$axios.formToJSON = (thing)=>(0, $0675de30d150073f$export$2e2bcd8739ae039)((0, $78b9035ccb9fa80d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$8b73d7db89efeff6$var$axios.getAdapter = (0, $21b08fac56477792$export$2e2bcd8739ae039).getAdapter;
$8b73d7db89efeff6$var$axios.HttpStatusCode = (0, $fcff87eec52eadf9$export$2e2bcd8739ae039);
$8b73d7db89efeff6$var$axios.default = $8b73d7db89efeff6$var$axios;
var // this module should only have a default export
$8b73d7db89efeff6$export$2e2bcd8739ae039 = $8b73d7db89efeff6$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $86ad93435fbefecf$export$1c00760e9e5a4e95, AxiosError: $86ad93435fbefecf$export$c1fbed17c2f6a328, CanceledError: $86ad93435fbefecf$export$1ab0c6b20d94fa14, isCancel: $86ad93435fbefecf$export$3b22524397b493c6, CancelToken: $86ad93435fbefecf$export$fd08e3cb425f0d61, VERSION: $86ad93435fbefecf$export$a4ad2735b021c132, all: $86ad93435fbefecf$export$84bf76cd7afc7469, Cancel: $86ad93435fbefecf$export$848c9b7ead0df967, isAxiosError: $86ad93435fbefecf$export$fbafdbe06a5b5a9a, spread: $86ad93435fbefecf$export$3ae0fd4797ed47c8, toFormData: $86ad93435fbefecf$export$10ae0d317ea97f8b, AxiosHeaders: $86ad93435fbefecf$export$4e7d6ff0f3e6520, HttpStatusCode: $86ad93435fbefecf$export$a972f69c851492b3, formToJSON: $86ad93435fbefecf$export$86d7c59254d6a2c9, getAdapter: $86ad93435fbefecf$export$17ddc20a97d669e2, mergeConfig: $86ad93435fbefecf$export$7ec1ebcfa9d8bd6a, create: $86ad93435fbefecf$export$185802fd694ee1f5 } = (0, $8b73d7db89efeff6$export$2e2bcd8739ae039);


const $43833d61576bcc02$var$user = "Th3Shadowbroker";
const $43833d61576bcc02$var$client = (0, $8b73d7db89efeff6$export$2e2bcd8739ae039).create({
    baseURL: "https://api.github.com"
});
const $43833d61576bcc02$var$placeholder = document.getElementById("contributions-placeholder");
const $43833d61576bcc02$var$showcase = document.getElementById("constributions-showcase");
const $43833d61576bcc02$var$columns = $43833d61576bcc02$var$showcase.childNodes;
function $43833d61576bcc02$var$reduceData(data) {
    return data.filter((fragment)=>fragment.description).map((fragment)=>{
        return {
            fullName: fragment.full_name,
            url: fragment.html_url,
            description: fragment.description,
            license: fragment.license?.spdx_id
        };
    });
}
function $43833d61576bcc02$var$generateElement(repository) {
    const el = document.createElement("div");
    el.classList.add('repository');
    el.addEventListener('click', ()=>window.open(repository.url, 'blank'));
    const name = document.createElement('div');
    name.classList.add('repository-name');
    name.innerText = repository.fullName;
    const description = document.createElement('div');
    description.classList.add('repository-description');
    description.innerText = repository.description;
    const license = document.createElement('div');
    const licenseIcon = document.createElement('span');
    const licenseName = document.createElement('span');
    license.classList.add("repository-license");
    licenseIcon.classList.add('fas');
    licenseIcon.classList.add('fa-balance-scale');
    licenseIcon.classList.add('license-icon');
    licenseName.innerText = repository.license ?? 'N/A';
    license.appendChild(licenseIcon);
    license.appendChild(licenseName);
    el.appendChild(name);
    el.appendChild(description);
    el.appendChild(license);
    return el;
}
function $43833d61576bcc02$var$toggleShowcase() {
    if ($43833d61576bcc02$var$placeholder.classList.contains("hidden")) {
        $43833d61576bcc02$var$placeholder.classList.remove("hidden");
        $43833d61576bcc02$var$showcase.classList.add("hidden");
    } else {
        $43833d61576bcc02$var$showcase.classList.remove("hidden");
        $43833d61576bcc02$var$placeholder.classList.add("hidden");
    }
}
function $43833d61576bcc02$var$populateShowcase(elements) {
    let column = 0;
    for (let element of elements){
        if (column > 2) column = 0;
        $43833d61576bcc02$var$columns[column].appendChild(element);
        column++;
    }
}
async function $43833d61576bcc02$var$fetchRepositories() {
    const request = $43833d61576bcc02$var$client.get(`/users/${$43833d61576bcc02$var$user}/repos?sort=updated&per_page=20`);
    const data = (await request).data;
    const repositories = $43833d61576bcc02$var$reduceData(data);
    const elements = repositories.slice(0, 6).map((repository)=>$43833d61576bcc02$var$generateElement(repository));
    $43833d61576bcc02$var$populateShowcase(elements);
    $43833d61576bcc02$var$toggleShowcase();
}
$43833d61576bcc02$var$fetchRepositories();


//# sourceMappingURL=templates.1f956e14.js.map
